<template>
    <div class="newsBannerPhone">
        <div class="block">
            <el-carousel height="200px">
            <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                <div class="itemImg" :style="`background-image:url('${baseUrl+'img/news/'+item.img}')`" @click="gotoNewsInfo(index)">
                    <div class="itemText">{{item.title}}</div>
                </div>
            </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>
<script>
import {getNewsData} from "../datas/newsData.js"
export default {
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
            bannerList:[]
        }
    },
    created(){
        this.render()
    },
    watch: {
        '$route' (to, from) {
            this.render()
        },
        '$i18n.locale'(){
            this.render()
        },
    },
    methods:{
        render(){
            this.bannerList = getNewsData()
        },
        gotoNewsInfo(index){
            this.$router.push('/newsDetails/'+index)
        }
    }
    // computed: {
    //     bannerList(){
    //         return [
    //            {img:'newsbanner1.png',text:this.$t("新闻1")},
    //            {img:'newsbanner2.png',text:this.$t("新闻2")},
    //            {img:'newsbanner3.png',text:this.$t("新闻3")},
    //            {img:'newsbanner1.png',text:this.$t("新闻1")},          
    //        ]
    //     }
    // },
}
</script>
<style lang="less">
.newsBannerPhone{
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        margin: 0;
    }
    .itemImg{
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
        position: relative;
        .itemText{
            color: #fff;
            position: absolute;
            bottom: 30px;
            font-size: 0.8rem;
            text-align: center;
            width: 100%;
            z-index: 1000;
        }
    }
    .itemImg::before{
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 100;
        opacity: 0.8;
        background-image: linear-gradient(rgba(1, 124, 164,0.2), #017CA4);
    }
    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }
    
    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }
}
</style>

<i18n>
{
  "en": {
    "新闻1":"[朝 闻 天下] Hubei Xiantao is full of horsepower to produce medical protective materials",
    "新闻2":"CCTV \"Newscast\" focuses on Xiantao! This time because ...", 
    "新闻3":"Hubei Daily Concerned about Xiantao: \"No Stop\" Enterprises Are \"Arsenals\""                                
  },
  "zh": {
    "新闻1":"[朝闻天下]湖北仙桃开足马力 生产医用防护物资",
    "新闻2":"央视《新闻联播》聚焦仙桃！这次是因为……", 
    "新闻3":"湖北日报关注仙桃：“停不得”企业就是“兵工厂”"   
  }
}
</i18n>

